export default __webpack_public_path__ + "static/media/delivery-guy.c0194ba7.png";